if (typeof G == 'undefined') G = {};
G.Animations = G.Animations || {};

G.Animations.getWaitingIconAnimation = function getWaitingIconAnimation() {

  var tween = null;

  return {
    animate: animate,
  };

  function animate(game, target) {
    var icon = G.Utils.find1stObjectWithName(target, "waitingIcon");

    if (icon) {
      icon.events.onDestroy.addOnce(stop);
      tween = game.add.tween(icon)
        .to(null, 16*5, Phaser.Easing.Linear.None, true, 0, -1)
      
      tween.onLoop.add(function() {
        icon.angle += 45;
      });
    }
  }

  function stop() {
    if (tween) {
      tween.stop();
      tween = null;
    }
  }
};